/** دسترسی به گزارش مرکز تماس: نقش admin/superadmin یا پرچم داده‌شده توسط مدیر اصلی. */

export function canAccessCallCenterReport(): boolean {

  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();

  if (r === 'admin' || r === 'superadmin') return true;

  return localStorage.getItem('admin_call_center_report_access') === '1';

}



export function setCallCenterReportAccessFromLogin(value: boolean | undefined | null): void {

  localStorage.setItem('admin_call_center_report_access', value ? '1' : '0');

}



export function clearCallCenterReportAccess(): void {

  localStorage.removeItem('admin_call_center_report_access');

}

